import { CdkDialogContainer } from '@angular/cdk/dialog';
import { CdkPortalOutlet } from '@angular/cdk/portal';
import { Component } from '@angular/core';

/** CDK container with BR appearance and focus after template bindings render. */
@Component({
  selector: 'br-popover-container',
  standalone: true,
  imports: [CdkPortalOutlet],
  template: '<ng-template cdkPortalOutlet></ng-template>',
  styleUrls: ['./popover-container.component.css'],
})
export class BrPopoverContainerComponent extends CdkDialogContainer {
  protected override _captureInitialFocus(): void {
    // A stable-zone programmatic open can precede the first *ngIf check.
    // Reuse CDK's focus trap once those controls exist; ignore a closed portal.
    queueMicrotask(() => {
      if (this._elementRef.nativeElement.isConnected) super._captureInitialFocus();
    });
  }
}
